<template>
  <div class="home-deposit">
    <h1 class="page-title title no-border">{{ $t("deposit.header") }}</h1>
    <div class="page-ct">
      <h4 class="title">
        {{ $t("deposit.title.deposit") }}
        <a :href="$t('deposit.button.help.url')" target="_blank" class="show-popup-help">
          {{$t('deposit.button.help')}}
        </a>
      </h4>
      <div class="section">
        <div class="alert alert-success" v-if="model.successMessage">
          {{ $t(model.successMessage) }}
        </div>
        <div v-if="model.errorMessage">
          <div v-if="!messageMaintenance">
            <div class="alert alert-danger" v-html="$t(model.errorMessage)"></div>
          </div>
          <div v-if="messageMaintenance">
            <div class="alert alert-danger" v-html="$t(model.errorMessage, {param0 : nameServiceTo })"></div>
          </div>
        </div>
        <div v-if="ntdFxMaintenance" class="alert alert-warning" v-html="$t('MSG_TRS_NAF_0193', {param0 : $t('trs.front.header.label.fx')})"></div>
        <div v-if="model.warningMessage" class="alert alert-warning">
          <div v-for="message in model.warningMessage" :key="message.id">
            <div v-html="$t(message)"></div>
          </div>
        </div>

        <div class="section-inner">
          <h5 class="title no-border">
            <span>{{ $t("deposit.header.1") }}</span>
          </h5>
          <div class="bank-list" data-toggle="buttons">
            <div class="row row-narrow">
              <div class="col-md-3" v-for="item in model.mapDirectDepostBank" :key="item.bankCode">
                <label :class="item.classActive" class="btn btn-border btn-block font-custom"
                  @click="updateBankCode(item)" :id="item.bankCode">
                  <input type="radio" name="bank" :value="item.bankCode" v-model="bankCode"/>
                  {{ item.bankName }}
                </label>
              </div>
              <div v-if="model.veritransAccount" class="col-md-3">
                <label class="btn btn-primary btn-block font-custom" id="searchBankId" style="text-align: center !important"
                  @click.prevent="openSearch()">
                  {{ $t("bank.account.button.search_bank") }}
                </label>
              </div>
            </div>
          </div>
          <hr class="border-light"/>

          <div class="box-ct">
            <form class="form-horizontal" name="depositInfo" novalidate @submit.prevent="depositConfirmCheck()">
              <div class="tab-content">
                <div class="tab-pane active">
                  <h5 class="title no-border">
                    <span>{{ $t("deposit.header.3") }}</span>
                  </h5>
                  <div class="bank-list" data-toggle="buttons">
                    <div class="row row-narrow">
                      <div class="col-md-3" v-for="item in serviceList" :key="item.key">
                        <label class="btn btn-border btn-block font-custom"
                          :class="[ { disabled: isDisableServices(item.key) }, { active: item.key === DEFAULT_SERVICE_ACTIVE }]">
                          <span>
                            <input type="radio" name="serviceTo" :value="item.key" v-model="serviceTo"/>
                          </span>
                          {{ $t(item.value) }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <h5 class="title no-border">
                <span>{{ $t("deposit.header.2") }}</span>
              </h5>
              <div class="form-group">
                <div class="col-md-4" style="padding-left: 0px">
                  <div class="input-group">
                    <input type="text" class="form-control input-lg moneyMask" name="amount"
                      v-model="amount" :placeholder="$t('withdrawal.placeholder.amount')" required
                           @blur="amountBlurEvent()" @keypress="amountKeyPress($event)" @keydown="amountKeyDown($event)" @keyup="amountKeyUp($event)" @input="removeJapaneseCharacters($event)"/>
                    <span class="input-group-addon currency-addon" style="padding: 10px 12px">
                      {{ $t("deposit.label.money") }}
                    </span>
                  </div>

                  <div class="error-messages ng-active" v-if="!isCorrectAmount">
                    <div>
                      {{ $t("deposit.alert.input.required") }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="col-md-4" style="padding-left: 0px">
                  <div class="text-left">
                    <button id="submit-btt" class="btn btn-success btn-lg">
                      {{ $t("deposit.label.deposit") }}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <hr class="border-light"/>
      <div class="page-meta">
        <div class="box-ct">
          <ul class="list-unstyled">
            <li>
              {{ $t("deposit.alert.danger.part1_1")}}{{ model.bjpMinAmount == null ? 0 : model.bjpMinAmount}}<span
                    class="yen">{{ $t("deposit.label.money")}}</span>{{ $t("deposit.alert.danger.part1_2") }}
            </li>
            <li>{{ $t("deposit.alert.danger.part2") }}</li>
            <li>{{ $t("deposit.alert.danger.part3") }}</li>
            <li>{{ $t("deposit.alert.danger.part4_0") }}</li>
            <li>
              {{ $t("deposit.alert.danger.part4_1") }}<a :href="model.depositPaymentUrl" target="_blank">{{
              $t("deposit.alert.danger.part4_2") }}</a>{{ $t("deposit.alert.danger.part4_3") }}
            </li>
          </ul>
        </div>
      </div>
      <div id="direct-deposit" class="box-ct"
        v-if="!model.eaAccount && !model.hasVirtualAccount">
        <h4 class="box-title title">
          <span>{{ $t("deposit.title.transfer_payment") }}</span>
        </h4>
        <div class="row">
          <div class="col-12">
            <p class="form-note">
              {{ $t("label.deposit.virtual_account.note1") }} <br/>
              {{ $t("label.deposit.virtual_account.note2") }}
            </p>
          </div>
        </div>
        <div class="row" style="display: block">
          <div class="text-center">
            <router-link :to="{ name: 'createVirtualBank' }">
              <a class="btn btn-success btn-md">
                {{ $t("label.deposit.btrn.virtual_account") }}
              </a>
            </router-link>
          </div>
        </div>
      </div>
      <div v-if="!model.eaAccount && model.hasVirtualAccount">
        <h4 class="box-title title">
          <span>{{ $t("deposit.title.transfer_payment") }}</span>
        </h4>
        <div class="box-ct">
          <div class="section">
            <div class="section-inner">
              <p>{{ $t("deposit.title.info1") }}</p>
              <div class="row row-narrow">
                <div class="col-md-6">
                  <table class="table table-striped table-noborder table-text-lg">
                    <tbody>
                    <tr>
                      <td width="30%">{{ $t("deposit.label.bank_name") }}</td>
                      <td width="70%"><strong>{{ model.amsCustomerBankInfoView.bankName }}</strong></td>
                    </tr>
                    <tr>
                      <td>{{ $t("deposit.label.branch_name") }}</td>
                      <td><strong>{{ model.amsCustomerBankInfoView.branchName }}</strong></td>
                    </tr>
                    <tr>
                      <td>{{ $t("deposit.label.account_type") }}</td>
                      <td><strong>{{ model.amsCustomerBankInfoView.bankAccClass }}</strong></td>
                    </tr>
                    <tr>
                      <td>{{ $t("deposit.label.account_number") }}</td>
                      <td><strong>{{ model.amsCustomerBankInfoView.accountNo }}</strong></td>
                    </tr>

                    <tr>
                      <td>{{ $t("deposit.label.account_holder") }}</td>
                      <td v-if="model.eaAccount"></td>
                      <td v-if="!model.eaAccount">
                        <p><strong>{{ model.amsCustomerBankInfoView.accountName }}</strong></p>
                        <span>{{ $t("deposit.message.not_used") }}</span>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="page-meta">
              <div class="box-ct">
                <ul class="list-unstyled">
                  <li>{{ $t("deposit.alert.virtual_acc_1") }}</li>
                  <li>{{ $t("deposit.alert.virtual_acc_3") }}</li>
                  <li>{{ $t("deposit.alert.virtual_acc_4") }}</li>
                  <li>
                    {{ $t("deposit.alert.virtual_acc_5_1")}}<a :href="model.depositPaymentUrl" target="_blank">{{
                    $t("deposit.alert.virtual_acc_5_2") }}</a>{{ $t("deposit.alert.virtual_acc_5_3") }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <form  id="submitBjp" action="" method="post"  accept-charset="shift-jis"  onsubmit="document.charset='shift-jis'">
        <input type="hidden" name="PORTAL_CODE" v-if="frm.POST_PORTAL_CODE" :value="frm.POST_PORTAL_CODE">
        <input type="hidden" name="SHOP_CODE" v-if="frm.POST_SHOP_CODE" :value="frm.POST_SHOP_CODE">
        <input type="hidden" name="BANK_CODE" v-if="frm.POST_BANK_CODE" :value="frm.POST_BANK_CODE">
        <input type="hidden" name="KESSAI_FLAG" v-if="frm.POST_KESSAI_FLAG" :value="frm.POST_KESSAI_FLAG">
        <input type="hidden" name="CTRL_NO" v-if="frm.POST_CTRL_NO" :value="frm.POST_CTRL_NO">
        <input type="hidden" name="TRAN_AMOUNT" v-if="frm.POST_TRAN_AMOUNT" :value="frm.POST_TRAN_AMOUNT">
        <input type="hidden" name="VALID_RETURN_URL" v-if="frm.POST_VALID_RETURN_URL" :value="frm.POST_VALID_RETURN_URL">
        <input type="hidden" name="INVALID_RETURN_URL" v-if="frm.POST_INVALID_RETURN_URL" :value="frm.POST_INVALID_RETURN_URL">
        <input type="hidden" name="CUST_NAME_1" v-if="frm.POST_CUST_NAME_1" :value="frm.POST_CUST_NAME_1">
        <input type="hidden" name="CUST_NAME_2" v-if="frm.POST_CUST_NAME_2" :value="frm.POST_CUST_NAME_2">
        <input type="hidden" name="CUST_NAME" v-if="frm.POST_CUST_NAME" :value="frm.POST_CUST_NAME">
        <input type="hidden" name="CUST_LNAME" v-if="frm.POST_CUST_LNAME" :value="frm.POST_CUST_LNAME">
        <input type="hidden" name="CUST_FNAME" v-if="frm.POST_CUST_FNAME" :value="frm.POST_CUST_FNAME">
        <input type="hidden" name="GOODS_NAME" v-if="frm.POST_GOODS_NAME" :value="frm.POST_GOODS_NAME">
        <input type="hidden" name="GOODS_NAME_KANA" v-if="frm.POST_GOODS_NAME_KANA" :value="frm.POST_GOODS_NAME_KANA">
        <input type="hidden" name="REMARKS_1" v-if="frm.POST_REMARKS_1" :value="frm.POST_REMARKS_1">
        <input type="hidden" name="REMARKS_2" v-if="frm.POST_REMARKS_2" :value="frm.POST_REMARKS_2">
        <input type="hidden" name="REMARKS_3" v-if="frm.POST_REMARKS_3" :value="frm.POST_REMARKS_3">
        <input type="hidden" name="CONC_DAY" v-if="frm.POST_CONC_DAY" :value="frm.POST_CONC_DAY">
        <input type="hidden" name="DUE_DAY" v-if="frm.POST_DUE_DAY" :value="frm.POST_DUE_DAY">
        <input type="hidden" name="UN_KESSAI_FLAG" v-if="frm.POST_UN_KESSAI_FLAG" :value="frm.POST_UN_KESSAI_FLAG">
      </form>

      <form  id="submitVeri" action="" method="post" accept-charset="shift-jis" target="_blank">
        <input type="hidden" name="skno" v-if="frm.skno" :value="frm.skno"  />
        <input type="hidden" name="bptn" v-if="frm.bptn" :value="frm.bptn" />
        <input type="hidden" name="bill" v-if="frm.bill" :value="frm.bill" />
      </form>
    </div>
  </div>
</template>

<script>
import ModalPlugin from "@/common/plugins/ModalPlugin.js";
import MobileDetect from "mobile-detect";
import $ from "jquery";
import {MENU_HOME, SET_ACTIVE_TAB_ID} from '@/store/modules/header/type';
import {createNamespacedHelpers} from "vuex";
import offModalEvent from "@/common/mixins/offModalEvent";
import {INPUT_NUMBER_ALLOW_KEY_CODE} from "@/common/constants";
import postDocTemplateMixin from "@/common/mixins/postDocTemplate";

const {mapActions: mapHeaderActions} = createNamespacedHelpers("header");


export default {
    data() {
        return {
            SERVICE_NAME: "deposit",
            DEFAULT_SERVICE_ACTIVE: "21",
            model: {},
            serviceList: [],
            serviceTo: 21,
            nameServiceTo: null,
            bankCode: null,
            bankName: null,
            bankNameKana: null,
            amount: '',
            isCorrectAmount: true,
            bankInfo: null,
            frm: {},
            messageMaintenance: false,
            ntdFxMaintenance: false,
        }
    },
    mixins: [offModalEvent, postDocTemplateMixin],
    created() {
        this[SET_ACTIVE_TAB_ID](MENU_HOME);
        this.initDeposit();
    },
    mounted() {
        this.getBankInfo();
    },
    destroyed() {
        this.offEventName(this.IConstants.EVENT_NAME.GET_SELECTED_BANK);
    },
    methods: {
        ...mapHeaderActions([
            SET_ACTIVE_TAB_ID
        ]),
        initDeposit() {
            const msg = this.getMessage();
            this.$service
                .getService(this.SERVICE_NAME)
                .initDeposit(msg)
                .then((result) => {
                    this.model = result;
                    this.getListServiceType();
                    this.ntdFxMaintenance = result.ntdFxMaintenance;
                    this.DEFAULT_SERVICE_ACTIVE = result.disableServices[21] ? "0" : "21";
                    this.serviceTo = result.disableServices[21] ? 0 : 21;
                });
        },
        getListServiceType() {
            const tempList = this.IConstants.getListServiceTypeTransfer();
            tempList.forEach((item) => {
                this.model.serviceTypeList.forEach((serviceType) => {
                    if (parseInt(item.key) === serviceType) {
                        this.serviceList.push(item);
                    }
                });
            });
        },
        isDisableServices: function (key) {
            let flag = false;
            Object.keys(this.model.disableServices).forEach((element) => {
                if (element === key) {
                    flag = true;
                    return flag;
                }
            });
            return flag;
        },
        updateBankCode: function (bankInfo) {
            this.bankCode = bankInfo.bankCode;
            this.bankName = encodeURIComponent(bankInfo.bankName);
            this.bankNameKana = bankInfo.bankNameKana ? encodeURIComponent(bankInfo.bankNameKana) : null;
        },
        openSearch: function () {
            this.$service
                .getService(this.SERVICE_NAME)
                .getBankVeritrans()
                .then((result) => {
                    this.$modal.searchBankVeritrans(result);
                });
        },
        getBankInfo: function () {
          ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.GET_SELECTED_BANK, (bankInfo) => {
                this.bankInfo = bankInfo;
                this.afterCloseSearchBankVertitrans();
            });
        },
        afterCloseSearchBankVertitrans: function () {
            if (this.bankInfo == null) {
                $("#searchBankId").removeClass("active");
            } else {
                this.updateBankCode(this.bankInfo);
                let flag = true;
                let myBank = {
                    bankCode: this.bankInfo.bankCode,
                    bankName: this.bankInfo.bankName,
                    bankNameKana: this.bankInfo.bankNameKana,
                    classActive: "active",
                };
                this.$cookie.set('myBank', myBank);
                for (let item in this.model.mapDirectDepostBank) {
                    let bank = this.model.mapDirectDepostBank[item];
                    if (bank.bankCode === this.bankInfo.bankCode) {
                        flag = false;
                        $("#" + bank.bankCode).removeClass("deactive");
                        $("#" + bank.bankCode).addClass("active");
                        $("#searchBankId").removeClass("active");
                    } else {
                        $("#" + bank.bankCode).removeClass("active");
                        $("#" + bank.bankCode).addClass("deactive");
                    }
                }
                if (flag === true) {
                    let INDEX_LAST_BANK = this.model.mapDirectDepostBank.length - 1;
                    this.model.mapDirectDepostBank.splice(INDEX_LAST_BANK, 1);
                    this.model.mapDirectDepostBank.splice(0, 0, myBank);
                    $("#searchBankId").removeClass("active");
                }
            }
        },
        amountBlurEvent: function () {
            let val = this.amount;
            this.amount = this.$options.filters.formatAmount(val, 8);
            this.isCorrectAmount = this.amount !== "";
        },
        amountKeyPress(e) {
            let isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
            if (isIOS) {
                let keyCode = e.keyCode || e.charCode;
                let charCode = e.charCode;
                let isArrow = (charCode == 0 && keyCode >= 37 && keyCode <= 40);
                let isSpecialCharacter = ((keyCode == 8) || (keyCode == 9) || (keyCode == 127)) || isArrow; // backspace, tab, delete
                let isNumber = (keyCode >= 48 && keyCode <= 57) ;  // numbers
                if (isNumber || isSpecialCharacter || keyCode == 44 || keyCode == 46) { // 44: comma, 46: dot
                    return true;
                } else {
                    e.preventDefault();
                    return false;
                }
            }
        },
        amountKeyUp(e) {
            let amount = e.target.value;
            let charCode = e.keyCode || e.which;
            const regexNotAllowSpecialCharacters = /[^\d,.]/g;

            amount = amount.replace(regexNotAllowSpecialCharacters,"");

            // Default keycode for android is 0 or 299
            if (charCode === 0 || charCode === 229) {
                charCode = this.getKeyCode(amount);
            }

            if (!INPUT_NUMBER_ALLOW_KEY_CODE.includes(charCode)) {
                e.target.value = amount.replace(/^[0-9,.]/, '');
            }

            const MAX_LENGTH = 10;
            if (amount && amount.length >= MAX_LENGTH) {
                amount = amount.replace(regexNotAllowSpecialCharacters,"");
                e.target.value = amount.substr(0, MAX_LENGTH);
                return false;
            } else {
                this.isCorrectAmount = true;
            }

            e.target.value = amount.replace(regexNotAllowSpecialCharacters, '');
            return false;
        },
        amountKeyDown: function (e) {
            let allowInputAfterSelected = window.getSelection().toString() !== '';
            let charCode = e.keyCode || e.which;
            const val = this.amount;
            const MAX_LENGTH = 10;

            if(!INPUT_NUMBER_ALLOW_KEY_CODE.includes(charCode) || e.shiftKey){
                e.preventDefault();
                return false;
            }

            if (!allowInputAfterSelected && val && val.length >= MAX_LENGTH && !(charCode == 37 || charCode == 38 || charCode == 39 || charCode == 40 || charCode == 8 || charCode == 46 || charCode == 116)) {
                e.preventDefault();
                return false;
            } else {
                this.isCorrectAmount = true;
            }
        },
        removeJapaneseCharacters(e) {
            let amount = e.target.value;
            const MAX_LENGTH = 10;
            const regexNotAllowSpecialCharacters = /[^\d,.]/g;
            e.target.value = amount.replace(regexNotAllowSpecialCharacters, '');

            if (amount && amount.length >= MAX_LENGTH) {
                amount = amount.replace(regexNotAllowSpecialCharacters,"");
                e.target.value = amount.substr(0, MAX_LENGTH);
                return false;
            }
        },
        getKeyCode(str) {
            return str.charCodeAt(str.length - 1);
        },
        depositConfirmCheck: function () {
            this.isCorrectAmount = !(this.amount === '' || this.amount === null);
            if (!this.isCorrectAmount) {
              return;
            }
            let amt = '';
            this.amountBlurEvent();
            $("#submit-btt").prop('disabled', true);
            amt = this.amount;
            if (amt) {
                amt.replace(/[^0-9]/g, '');
                const config = {
                    amount: this.amount,
                    bankCode: this.bankCode,
                    bankName: this.bankName,
                    bankNameKana: this.bankNameKana,
                    serviceTo: this.serviceTo
                };
                this.$service.getService(this.SERVICE_NAME).depositConfirmCheck(config)
                    .then((result) => {
                        if (result) {
                            if (result.bjpInfo) {
                                if (result.bjpInfo.valid == 1) {
                                    this.frm = result.bjpInfo;
                                    if (result.bjpInfo.POST_BANK_CODE) {
                                        this.frm.POST_BANK_CODE = this.ServiceUtils.getUpperCaseKana(this.ServiceUtils.halfFullConvert(result.bjpInfo.POST_BANK_CODE, true));
                                    }
                                    if (result.bjpInfo.POST_KESSAI_FLAG) {
                                        this.frm.POST_KESSAI_FLAG = this.ServiceUtils.getUpperCaseKana(this.ServiceUtils.halfFullConvert(result.bjpInfo.POST_KESSAI_FLAG, true));
                                    }
                                    if (result.bjpInfo.POST_CUST_NAME) {
                                        this.frm.POST_CUST_NAME = this.ServiceUtils.getUpperCaseKana(this.ServiceUtils.halfFullConvert(result.bjpInfo.POST_CUST_NAME, false));
                                    }
                                    if (result.bjpInfo.POST_CUST_LNAME) {
                                        this.frm.POST_CUST_LNAME = this.ServiceUtils.getUpperCaseKana(this.ServiceUtils.halfFullConvert(result.bjpInfo.POST_CUST_LNAME, false));
                                    }
                                    if (result.bjpInfo.POST_CUST_FNAME) {
                                        this.frm.POST_CUST_FNAME = this.ServiceUtils.getUpperCaseKana(this.ServiceUtils.halfFullConvert(result.bjpInfo.POST_CUST_FNAME, false));
                                    }
                                    if (result.bjpInfo.POST_GOODS_NAME) {
                                        this.frm.POST_GOODS_NAME = this.ServiceUtils.replaceInvalidBjpCharacters(result.bjpInfo.POST_GOODS_NAME);
                                    }
                                    if (result.bjpInfo.POST_GOODS_NAME_KANA) {
                                        this.frm.POST_GOODS_NAME_KANA = this.ServiceUtils.replaceInvalidBjpCharacters(result.bjpInfo.POST_GOODS_NAME_KANA);
                                    }
                                    if (result.bjpInfo.POST_REMARKS_1) {
                                        this.frm.POST_REMARKS_1 = this.ServiceUtils.replaceInvalidBjpCharacters(result.bjpInfo.POST_REMARKS_1);
                                    }
                                    if (result.bjpInfo.POST_REMARKS_2) {
                                        this.frm.POST_REMARKS_2 = this.ServiceUtils.replaceInvalidBjpCharacters(result.bjpInfo.POST_REMARKS_2);
                                    }
                                    this.$mount();
                                    $("#submitBjp").attr('action', result.bjpInfo.BJP_URL);
                                    $("#submitBjp").attr('charset', 'shift_jis');
                                    $("#submitBjp").submit();
                                } else {
                                    this.model.successMessage = null;
                                    this.model.errorMessage = result.bjpInfo.msg;
                                    if ('MSG_NAB095' === result.bjpInfo.msg) {
                                        this.model.errorMessage = this.$t(result.bjpInfo.msg, {param1: (this.model.minTransferAmount + this.$t("currency.japanese.yen"))});
                                    } else {
                                        this.model.errorMessage = result.bjpInfo.msg;
                                    }
                                }
                            } else {
                                if (result.veriInfo) {
                                    const mobileDetect = new MobileDetect(navigator.userAgent);
                                    const isMobile = mobileDetect.mobile();
                                    if (mobileDetect.is('iOS') || mobileDetect.is('AndroidOS') || isMobile != null) {
                                        $("#submitVeri").removeAttr("target");
                                    }
                                    this.frm = result.veriInfo;
                                    this.frm.skno = result.veriInfo.pay_no1;
                                    this.frm.bptn = result.veriInfo.pay_no4;
                                    this.frm.bill = result.veriInfo.pay_no5;
                                    this.$mount();
                                    $("#submitVeri").attr('action', result.veriInfo.pay_no3);
                                    $("#submitVeri").attr('charset', 'shift_jis');
                                    $("#submitVeri").submit();
                                } else {
                                    this.model.successMessage = null;
                                    this.nameServiceTo = this.IConstants.getServiceTypeName(result.serviceTo, this.IConstants.getMapAccountTypePeriodReport(false));
                                    this.messageMaintenance = result.errorMessage === "MSG_TRS_NAF_0193";
                                    this.model.errorMessage = result.errorMessage;
                                }
                            }
                            window.scrollTo(0, 0);
                        } else {
                            window.scrollTo(0, 0);
                        }
                    });
                setTimeout(function () {
                    $("#submit-btt").prop('disabled', false);
                }, 2000);
            } else {
                setTimeout(function () {
                    $("#submit-btt").prop('disabled', false);
                }, 5000);
            }
        },
        getMessage: function () {
            const msg = this.$route.query.msg;
            if (msg) {
                return msg;
            }
            let url = location.href;
            if (url.indexOf("?") > 0) {
                try {
                    let param = url.substring(url.indexOf("?") + 1);
                    return param.substring(param.indexOf("?") + 1).split("=")[1];
                } catch (e) {
                    return '';
                }
            } else {
                return '';
            }
        }
    },
};
</script>

<style scoped>
  .disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  @media screen and (max-width: 900px) {
    .btn-border{
      font-size: small;
    }
  }

  .table td {
    color: #555555;
  }
  .font-custom{
    font-size: 14px;
  }

  .show-popup-help {
    display: inline-block;
    background-color: #ff9900;
    border: 3px solid #ff9900;
    padding: 7px;
    color: #ffffff;
    font-size: 12px;
    float: right;
    border-radius: 20px;
  }
  .show-popup-help:hover {
    background-color: #ffffff;
    border: 3px solid #ff9900;
    color: #ff9900;
  }

</style>
